import React from 'react';
import Store from '../Common/Store'
import { FaTasks } from "react-icons/fa";
import { TiArrowBack } from "react-icons/ti";
import * as Style from './Common/StyledComponents'

class TaskHeader extends React.Component
{
    render()
    {
        let config_url = process.env.REACT_APP_TMVIEW_URL;
        return (
            <Style.HeadContainer>
                <Style.HomeLogo><FaTasks /></Style.HomeLogo>
                <Style.HomeText><span style={{fontWeight: "600"}}>Task Manager: Compliance Advice Register Task Viewer</span></Style.HomeText>
                <Style.Categories><a href={config_url}><TiArrowBack /></a></Style.Categories>
                <div style={{clear: "both"}}></div>
            </Style.HeadContainer>
        );
    }
}
export default TaskHeader;
